import styled from "styled-components";

export const LabelStyled = styled.label`
  font-size: 15px;
  color: ${({ theme }) => theme.colors.text.lightBlack};
  margin-bottom: 5px !important;
  display: block;
`;
